module.exports = __webpack_public_path__ + "57c663940c20f1247d76a93ba35b3b3d.pdf";